import Immutable from 'seamless-immutable';
import pathOr from 'ramda/src/pathOr';
import { VALIDATE_ADDRESS_CONSTANTS, RESET_ADDRESS_COMPONENT, SET_ADDRESS_TO_BE_VALIDATED, SET_ADDRESS_KEY_FOR_ADDRESS_BEING_VALIDATED_THROUGH_API, SET_ADDRESS_KEY_FOR_ADDRESS_PREVIOUSLY_VALIDATED_THROUGH_API, SET_ADDRESS_TO_VALIDATED_ADDRESSES, SET_FORCE_SHOW_EDIT_FORM_ADDRESSES_COMPONENT, SET_SUGGESTED_ADDRESS_TO_VALIDATED_ADDRESSES, SET_EDIT_ADDRESS_BACK_TO_INVALID } from './actions/address.component.actions';
import { generateKeyFromAddress } from './helpers/address.helper';
import { ADDRESS_STATUS_CONSTANTS } from '../components/customer/addresses/addresses.constants';
export var INITIAL_STATE = Immutable({
  addressBeingValidated: null,
  isForceShowEditForm: false,
  isValidating: false,
  lastJobToken: null,
  mduRange: null,
  needToValidate: false,
  previousAddressValidated: null,
  unvalidatedAddresses: {},
  //This is where we will store the addresses we tried to validate
  validatedAddresses: {} //stored response from API for each validated address
});
export default function AddressesComponentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_ADDRESS_TO_BE_VALIDATED:
      return state.setIn(['unvalidatedAddresses'], processAddress(state.unvalidatedAddresses, payload));
    //          TO-DO should we have a reset state otherwise addresses key too large?
    case RESET_ADDRESS_COMPONENT:
      return INITIAL_STATE;
    case SET_ADDRESS_KEY_FOR_ADDRESS_BEING_VALIDATED_THROUGH_API:
      return state.setIn(['addressBeingValidated'], payload);
    case SET_ADDRESS_KEY_FOR_ADDRESS_PREVIOUSLY_VALIDATED_THROUGH_API:
      return state.setIn(['previousAddressValidated'], payload);
    case SET_SUGGESTED_ADDRESS_TO_VALIDATED_ADDRESSES:
      return state.setIn(['validatedAddresses', generateKeyFromAddress(payload.address)], {
        ValidatedAddress: payload.address,
        JobToken: jobTokenFromResponse(payload)
      });
    case SET_EDIT_ADDRESS_BACK_TO_INVALID:
      return state.setIn(['validatedAddresses', generateKeyFromAddress(payload.address)], payload.response);
    case SET_ADDRESS_TO_VALIDATED_ADDRESSES:
      return state.setIn(['validatedAddresses', generateKeyFromAddress(payload.address)], {
        ValidatedAddress: payload.address,
        JobToken: jobTokenFromResponse(payload),
        AddressValidationStatus: payload.AddressValidationStatus
      });
    case SET_FORCE_SHOW_EDIT_FORM_ADDRESSES_COMPONENT:
      return state.setIn(['isForceShowEditForm'], payload);
    case VALIDATE_ADDRESS_CONSTANTS.BEGIN:
      return state.setIn(['isValidating'], true);
    case VALIDATE_ADDRESS_CONSTANTS.SUCCESS:
      return state.setIn(['isValidating'], false).setIn(['mduRange'], getMduRange(payload)).setIn(['validatedAddresses', state.addressBeingValidated], compareAddress(payload)).setIn(['lastJobToken'], jobTokenFromResponse(payload));
    case VALIDATE_ADDRESS_CONSTANTS.FAILURE:
      return state.setIn(['isValidating'], false).setIn(['lastJobToken'], jobTokenFromResponse(payload));
    default:
      return state;
  }
}
var getMduRange = function getMduRange(payload) {
  if (payload.AddressValidationStatus === ADDRESS_STATUS_CONSTANTS.MDU_VALIDATION_ERROR && payload.SuggestedAddresses) {
    var mduSuggestedAddress = payload.SuggestedAddresses.find(function (address) {
      return address.MduRange;
    });
    return mduSuggestedAddress && mduSuggestedAddress.MduRange;
  }
  return null;
};

// if requested and validated address are different, then show the validated address as suggestion
var compareAddress = function compareAddress(payload) {
  if (payload.ValidatedAddress && payload.RequestedAddress && !payload.AddressValidationStatus) {
    var valAddress = payload.ValidatedAddress;
    var reqAddress = payload.RequestedAddress;
    var addressKeys = ['LineOne', 'LineTwo', 'City', 'Country', 'PostalCode', 'State'];
    var isAddressSame = addressKeys.every(function (key) {
      // eslint-disable-next-line no-prototype-builtins
      reqAddress.hasOwnProperty(key) && reqAddress[key] === valAddress[key];
    });
    if (!isAddressSame) {
      payload = {
        RequestedAddress: reqAddress,
        SuggestedAddresses: [valAddress]
      };
      return payload;
    }
  } else if (payload.AddressValidationStatus === ADDRESS_STATUS_CONSTANTS.MDU_VALIDATION_ERROR && payload.SuggestedAddresses) {
    delete payload.SuggestedAddresses;
    return payload;
  }
  return payload;
};
var jobTokenFromResponse = function jobTokenFromResponse(payload) {
  return pathOr(null, ['ContextData', '0', 'Value'], payload) || pathOr(null, ['JobToken'], payload);
};
var processAddress = function processAddress(addresses, payload) {
  /*
      - Verify if `ValidatedADdress` matches the address from request
      - Make sure validatedAddress is processed correctly from generateKeyFromAddress
  */
  var key = generateKeyFromAddress(payload);
  if (addresses[key]) {
    return addresses;
  } else {
    return addresses.setIn([key], Object.assign({}, {
      addressLine1: payload.addressLine1,
      addressLine2: payload.addressLine2,
      city: payload.city,
      country: payload.country,
      postalCode: payload.postalCode,
      stateRegionProvince: payload.stateRegionProvince
    }));
  }
};